import * as React from 'react';
import i18n from '../i18n';
import { ErrorPageContent } from './ErrorPageContent';

export const NotFoundPage: React.FC<{}> = () => (
  <ErrorPageContent errorTitle={i18n.t("errorPages.notFoundTitle")} errorMessage={i18n.t("errorPages.notFoundMessage")} />
);
